import { RefDirective } from './ref.directive';
import { UlComponent } from './ul.component';
import { IFrameComponent } from './iframe.component';
import { XRefDirective } from './xref.directive';
import { SpinnerComponent } from './spinner.component';
import { HSpinnerComponent } from './hspinner.component';
import { SilterStampComponent } from './filter-stamp/filter-stamp.component.js';

export const scSharedModule = 'sc-shared';

angular.module(scSharedModule, [])
  .directive('scRef', RefDirective)
  .directive('scXref', XRefDirective)
  .directive('scUl', UlComponent)
  .component('scIframe', IFrameComponent)
  .component('scSpinner', SpinnerComponent)
  .component('scHspinner', HSpinnerComponent)
  .component('scFilterStamp', SilterStampComponent)
;



// WEBPACK FOOTER //
// ./src/shared/shared.module.js